class TouchendDirective {
    constructor() {
        this.restrict = 'A';
    }

    link(scope, element, attrs) {
        element.on('touchend', function(event) {
            scope.$event = event;
            scope.$apply(function() {
                scope.$eval(attrs.touchend);
            });
        });
        element.on('mouseup', function(event) {
            scope.$event = event;
            scope.$apply(function() {
                scope.$eval(attrs.touchend);
            });
        });
    }

    static directiveFactory() {
        'ngInject';
        return new TouchendDirective();
    }
}

export default TouchendDirective;
